import { useDynamicConfig } from '@statsig/react-bindings';

import EidCampaignHero from './_heros/EidCampaignHero';
import GiveUsTheFingerHero from './_heros/GiveUsTheFingerHero';
import NewYearHealthHero from './_heros/NewYearHealthHero';
import OR4CeramicHero from './_heros/OR4CeramicHero';
import OR4Hero from './_heros/OR4Hero';
import ValentinesDayHero from './_heros/ValentinesDayHero';

const heroLookup: Record<string, () => React.JSX.Element> = {
  EidCampaignHero,
  GiveUsTheFingerHero,
  OR4CeramicHero,
  OR4Hero,
  NewYearHealthHero,
  ValentinesDayHero,
};

type HeroType =
  | 'EidCampaignHero'
  | 'GiveUsTheFingerHero'
  | 'OR4CeramicHero'
  | 'OR4Hero'
  | 'NewYearHealthHero'
  | 'ValentinesDayHero';

// If statsig misbehaves we will fallback to this
const FallbackHero = OR4Hero;

const HomeHeroGate = () => {
  const configHero = useDynamicConfig('home_hero').get(
    'hero',
    'OR4Hero',
  ) as HeroType;

  const Hero = heroLookup[configHero];

  return Hero ? <Hero /> : <FallbackHero />;
};

export default HomeHeroGate;
